export default __webpack_public_path__ + "static/litecoin-438599a1d4c1e9524ed407580254270a.png";